import script from "./DriverMessageRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriverMessageRow.vue?vue&type=script&setup=true&lang=ts"

import "./DriverMessageRow.vue?vue&type=style&index=0&id=7f812409&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f812409"]])

export default __exports__